import { Flow_0_0_2 } from '@flexus/core';

export const BET_30: Flow_0_0_2 = {
	id: '30',
	name: 'second_payment_approval',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Wait for SP to confirm payment'
		},
		viewRoles: {
			0: 'Wait for SP to confirm payment'
		}
	},
	startNode: '',
	nodes: {}
};
